export const RECENTS_LIST = 'dashboard/RECENTS_LIST';
export const RECENTS_LIST_ASYNC = 'dashboard/RECENTS_LIST_ASYNC';
export const DASHBOARD_RECENT_URL = '/recent_items';
